import { __decorate } from "tslib";
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import FormHeaderMixin from '@/helpers/vue_mixins/v2/FormHeaderMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import NumericInput from '@/components/v2/NumericInput.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import BaseTextArea from '@/components/v2/BaseTextArea';
import VEditorField from '@/components/v2/VEditorField.vue';
import BaseDetails from '@/components/v2/BaseDetails';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import Freebies from '@/components/v2/ecommerce/Freebies';
import Categories from '@/components/v2/Categories';
import DeliveryAreaRegions from '@/components/v2/ecommerce/DeliveryAreaRegions';
import DeliveryAreaCities from '@/components/v2/ecommerce/DeliveryAreaCities';
import TheDiyActions from '@/components/v2/diy/TheDiyActions.vue';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import SubCategories from '@/components/v2/ecommerce/SubCategories';
import Uploader from '@/components/v2/Uploader';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import { required, numeric, requiredIf, decimal } from 'vuelidate/lib/validators';
import { requiredProperty, uniqueProperty } from '@/helpers/mixins/LocalizationHelper';
import { Getter, Mutation } from 'vuex-class';
import { ProductCategory } from '@/helpers/entities/enums/v2/ProductCategory';
import { KycLevel } from '@/helpers/entities/enums/v2/KycLevel';
import { Variances } from '@/helpers/entities/enums/v2/Variances';
import { VueEditor } from 'vue2-editor';
import { EcommerceProductSectionInputModel } from '@/helpers/entities/models/EcommerceProductSectionInputModel';
import { EcommerceProductRegionAvailabilityInputModel } from '@/helpers/entities/models/EcommerceProductRegionAvailabilityInputModel';
import { EcommerceProductDetailsInputModel } from '@/helpers/entities/models/EcommerceProductDetailsInputModel';
import { EcommerceProductPromoInputModel } from '@/helpers/entities/models/EcommerceProductPromoInputModel';
import { EcommerceProductCategoryInputModel } from '@/helpers/entities/models/EcommerceProductCategoryInputModel';
import { EcommerceProductVariantInputModel } from '@/helpers/entities/interfaces/v2/model_implementations/EcommerceProductVariantInputModel';
import { TaxType as DiscountType } from '@/helpers/entities/enums/v2/TaxType';
import { isNotFirstInstance } from '@/helpers';
import { DIY } from '@/helpers/constants/Store';
import { State } from '@/helpers/entities/enums/v2/State';
import { pick, includes } from 'lodash';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import SegmentAnalyticsMixin from '@/helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { EcommerceProductCityPriceHikeInputModel } from '@/helpers/entities/models/EcommerceProductCityPriceHikeInputModel';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
let ProductForm = class ProductForm extends Mixins(Mixins(FormHeaderMixin, FormMixin), AppDetailsMixin, DiyMixin, ViewportSizeMixin, SegmentAnalyticsMixin) {
    constructor() {
        super(...arguments);
        this.disableVarianceFields = false;
        this.varianceExists = false;
        this.disablePromoFields = false;
        this.promoExists = false;
        this.fileExceeded = false;
        this.hasRejectedFiles = false;
        this.enableDependentStock = false;
        // private disabledAddOnsFields = false;
        // private addOnsExists = false;
        /**
         * Vue2 Editor Custom Toolbar Configuration
         * @author Angelo David <adavid@gorated.ph>
         * @since Version {0.76.1}
         * @reference https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/default-toolbar.js
         */
        this.vueEditorCustomToolbar = [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ color: [] }, { background: [] }],
        ];
        this.form = {
            name: null,
            description: null,
            price: 0,
            compareAtPrice: 0,
            quantity: null,
            category: ProductCategory.physicalSale,
            limited: false,
            enableVariances: false,
            enableDependentStock: false,
            productSections: [],
            productDetails: [],
            enablePromos: false,
            productPromo: null,
            productCategories: [new EcommerceProductCategoryInputModel()],
            images: [],
            totalItemSold: null,
            requiredKyc: false,
            kycLevel: null,
            enableProductRemarks: false,
            remarksLabel: null,
            enableProductLocationAvailability: false,
            productRegionAvailabilities: [],
            regions: [],
            skuMatCode: null,
            // productAddOns: [],
            productVariants: [],
            digitalProduct: false,
            // enableAddOn: false,
            width: null,
            height: null,
            length: null,
            weight: null,
        };
    }
    get loadingTitle() {
        if (this.uploadingImage) {
            return 'Uploading Images...';
        }
        if (this.diy) {
            return '';
        }
        return 'Saving Product...';
    }
    pushNewProductVariant() {
        if (this.enableDependentStock && this.form.productVariants.length === 0) {
            this.addProductVariant();
        }
    }
    setEnableDependentStock() {
        this.enableDependentStock = true;
    }
    goToEnterprisePlan() {
        this.$router.push({ name: 'enterprise-plans' });
    }
    togglePermutationForm(val) {
        const vm = this;
        if (val) {
            this.setEnableDependentStock();
            vm.$refs.permutationForm.toggle = true;
        }
        else {
            this.form.enableDependentStock = false;
        }
    }
    get undeletedProductSections() {
        return this.form.productSections.filter(({ state }) => state !== State.deleted);
    }
    get isB2cBundle() {
        return this.$route.params.key === Bundle.Ecommerce;
    }
    get isInsuranceBundle() {
        return this.$route.params.key === Bundle.Insurance;
    }
    get componentUuid() {
        return this.$route.params.componentUUID || this.productComponentUuid;
    }
    canBeMarkedAsDeleted(sec) {
        if (this.update && sec.$model.state !== 'idle') {
            return true;
        }
        if (!this.update) {
            return true;
        }
        return false;
    }
    get productCategories() {
        const options = [
            selectOptionBuilder(ProductCategory.physicalSale, 'Physical Product'),
            selectOptionBuilder(ProductCategory.digitalSale, 'Digital Product'),
        ];
        if (!this.update) {
            options.push(selectOptionBuilder(ProductCategory.freebie));
        }
        return options;
    }
    get kycLevels() {
        return [
            selectOptionBuilder(String(KycLevel.One), 'Level 1'),
            selectOptionBuilder(String(KycLevel.Two), 'Level 2'),
        ];
    }
    get paymentOptionTypes() {
        return [
            selectOptionBuilder('to_all', 'All'),
            selectOptionBuilder('cod', 'Cash On Delivery'),
            selectOptionBuilder('bank', 'Bank Deposit'),
            selectOptionBuilder('bpi', 'BPI'),
            selectOptionBuilder('gcash', 'GCash'),
            selectOptionBuilder('credit_card', 'Card Payments (Mastercard, VISA, JCB)'),
        ];
    }
    get kycLevelHint() {
        if (!this.form.kycLevel) {
            return null;
        }
        if (this.form.kycLevel === 1) {
            return 'Capture selfie and upload ID';
        }
        return 'Capture selfie, upload ID and upload proof of income';
    }
    get action() {
        return this.update ? 'Edit' : 'Create';
    }
    get hasProductSections() {
        return this.form.productSections.length >= 1;
    }
    // private get hasProductAddOns() {
    //   return this.form.productAddOns.length >= 1;
    // }
    get nameErrors() {
        const errors = [];
        if (!this.$v.form.name.$dirty) {
            return errors;
        }
        if (!this.$v.form.name.required) {
            const msg = requiredProperty('Name');
            errors.push(msg);
        }
        return errors;
    }
    get descriptionErrors() {
        const errors = [];
        if (!this.$v.form.description.$dirty) {
            return errors;
        }
        if (!this.$v.form.description.required) {
            const msg = requiredProperty('Description');
            errors.push(msg);
        }
        return errors;
    }
    get priceErrors() {
        const errors = [];
        if (!this.$v.form.price.$dirty) {
            return errors;
        }
        if (!this.$v.form.price.required) {
            const msg = requiredProperty('Price');
            errors.push(msg);
        }
        return errors;
    }
    get compareAtErrors() {
        const errors = [];
        if (!this.$v.form.compareAtPrice.validCompareAt) {
            const msg = 'Product Compare At Price should be more than price';
            errors.push(msg);
        }
        return errors;
    }
    optionCompareAtErrors(v) {
        const errors = [];
        if (!v.validCompareAt) {
            const msg = 'Variant Compare At Price should be more than price';
            errors.push(msg);
        }
        return errors;
    }
    variantCompareAtErrors(price, compareAt = 0.0) {
        const errors = [];
        if (compareAt > 0.0 && price > 0.0 && price > compareAt) {
            const msg = 'Variant Compare At Price should be more than price';
            errors.push(msg);
        }
        return errors;
    }
    get weightErrors() {
        const errors = [];
        if (!this.$v.form.weight.$dirty) {
            return errors;
        }
        if (this.$v.form.weight.$model >= 600) {
            errors.push('Weight must be less than 600kg');
        }
        if (!this.$v.form.weight.required) {
            const msg = requiredProperty('Weight');
            errors.push(msg);
        }
        return errors;
    }
    get heightErrors() {
        const errors = [];
        if (!this.$v.form.height.$dirty) {
            return errors;
        }
        if (this.$v.form.height.$model >= 40.8) {
            errors.push('Height must be less than 40.8 inches');
        }
        if (!this.$v.form.height.required) {
            const msg = requiredProperty('Height');
            errors.push(msg);
        }
        return errors;
    }
    get lengthErrors() {
        const errors = [];
        if (!this.$v.form.length.$dirty) {
            return errors;
        }
        if (this.$v.form.length.$model >= 84) {
            errors.push('Length must be less than 84 inches');
        }
        if (!this.$v.form.length.required) {
            const msg = requiredProperty('Length');
            errors.push(msg);
        }
        return errors;
    }
    get widthErrors() {
        const errors = [];
        if (!this.$v.form.width.$dirty) {
            return errors;
        }
        if (this.$v.form.width.$model >= 48) {
            errors.push('Width must be less than 48 inches');
        }
        if (!this.$v.form.width.required) {
            const msg = requiredProperty('Width');
            errors.push(msg);
        }
        return errors;
    }
    get quantityErrors() {
        const errors = [];
        if (!this.$v.form.quantity.$dirty) {
            return errors;
        }
        if (!this.$v.form.quantity.required) {
            const msg = requiredProperty('Quantity');
            errors.push(msg);
        }
        if (!this.$v.form.quantity.validStockQuantity) {
            const msg = 'Stock quantity must be greater than -1';
            errors.push(msg);
        }
        return errors;
    }
    get remarksLabelErrors() {
        const errors = [];
        if (!this.$v.form.remarksLabel.$dirty) {
            return errors;
        }
        if (!this.$v.form.remarksLabel.required) {
            const msg = requiredProperty('Remarks Label');
            errors.push(msg);
        }
        return errors;
    }
    get variances() {
        return [
            selectOptionBuilder(Variances.size),
            selectOptionBuilder(Variances.color),
            selectOptionBuilder(Variances.material),
            selectOptionBuilder(Variances.title),
        ];
    }
    get discountTypes() {
        return [
            selectOptionBuilder(DiscountType.absolute, 'Absolute'),
            selectOptionBuilder(DiscountType.percentage),
        ];
    }
    get promoDiscountErrors() {
        const errors = [];
        if (!this.$v.form.productPromo.discount.$dirty) {
            return errors;
        }
        if (!this.$v.form.productPromo.discount.required) {
            const msg = requiredProperty('Promo Discount');
            errors.push(msg);
        }
        if (!this.$v.form.productPromo.discount.mustBeLessThanPrice) {
            errors.push('Discount Price must be less than the Product Price');
        }
        return errors;
    }
    get categories() {
        const collection = this.$v.form.productCategories.$each.$iter || {};
        const result = Object.values(collection).reduce((acc, val) => {
            if (!!val && !!val.$model && !val.$model.isDeleted) {
                acc.push(val);
            }
            return acc;
        }, []);
        return result;
    }
    get publishedVariantsCount() {
        let count = 0;
        for (let x = 0; x < this.form.productVariants.length; x++) {
            count += this.form.productVariants[x].published ? 1 : 0;
        }
        return count;
    }
    syncedCategories(dataCategories) {
        return (dataCategories?.map((category) => {
            const productCat = this.form.productCategories.find((pc) => pc.name === category.name);
            const val = productCat?.uuid || category.uuid;
            return selectOptionBuilder(val, category.name);
        }) || []);
    }
    syncedSubcategories(subcategories, data) {
        return (subcategories?.map((subcategory) => {
            const productSc = data.$model.find((sc) => sc.name === subcategory.name);
            const val = productSc?.uuid || subcategory.uuid || '';
            return selectOptionBuilder(val, subcategory.name);
        }) || []);
    }
    syncedFreebies(dataFreebies) {
        return (dataFreebies?.map((freebie) => {
            const productFreebie = this.form.productPromo?.freebies.find((f) => f.name === freebie.name);
            const val = productFreebie?.uuid || freebie.uuid;
            return selectOptionBuilder(val, freebie.name);
        }) || []);
    }
    get formHeader() {
        return this.header || `${this.action} Product`;
    }
    get isProductFreebie() {
        return this.form.category === ProductCategory.freebie;
    }
    get isVarianceEnabled() {
        return this.form.enableVariances;
    }
    get isDigitalProduct() {
        return this.form.category === ProductCategory.digitalSale;
    }
    get isPhysicalProduct() {
        return this.form.category === ProductCategory.physicalSale;
    }
    get allowAppProductRemarks() {
        return !!this.appDetails && !this.appDetails.allowProductRemarks;
    }
    optionStockHint(soldCount, limited) {
        if (soldCount > 0 && limited) {
            return `Sold: ${soldCount}`;
        }
        return null;
    }
    disableOptionQuantity(invalid) {
        if (invalid || this.disableVarianceFields) {
            return true;
        }
        return false;
    }
    disabledPublishToggle(section) {
        const publishedSections = this.form.productSections.filter((vars) => vars.published && vars.state !== 'deleted');
        if (publishedSections.length <= 1 && section.published.$model) {
            return true;
        }
        return false;
    }
    onFormChanged(form) {
        const attrs = [
            'name',
            'description',
            'price',
            'compareAtPrice',
            'productSections',
            'productDetails',
            'images',
            'skuMatCode',
        ];
        const payload = pick(form, attrs);
        this.updateProductDetails(payload);
    }
    updatePriceForFreebie() {
        if (this.isProductFreebie) {
            this.form.price = 0.0;
        }
    }
    checkRejectedFiles() {
        const self = this;
        this.hasRejectedFiles = !!self.$refs.uploader.getRejectedFiles().length;
    }
    fileExceed() {
        this.fileExceeded = true;
        this.checkRejectedFiles();
    }
    productCategoryErrors(v) {
        const errors = [];
        const label = 'Product Category';
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty(label);
            errors.push(msg);
        }
        if (!v.unique) {
            const msg = uniqueProperty(label);
            errors.push(msg);
        }
        return errors;
    }
    productAddOnsErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty('Add on name');
            errors.push(msg);
        }
        if (!v.unique) {
            const msg = uniqueProperty('Add on name');
            errors.push(msg);
        }
        return errors;
    }
    productSubCategoryErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty('Product Sub Category');
            errors.push(msg);
        }
        return errors;
    }
    addProductDetails() {
        const details = new EcommerceProductDetailsInputModel();
        this.form.productDetails.push(details);
    }
    // private addAddOns() {
    //   const details = new EcommerceProductAddOnInputModel();
    //   this.form.productAddOns.push(details);
    // }
    setProductOptionDefaultPrice(productSections, basePrice) {
        productSections.forEach((section) => {
            section.productOptions.forEach((option) => {
                option.price = option.price === 0 ? basePrice : option.price;
            });
        });
    }
    addProductVariant() {
        const details = new EcommerceProductVariantInputModel();
        this.form.productVariants.push(details);
    }
    // The wrapper function is for the index counter
    buildVariantPermutationsWrapper(sectionsWrapper) {
        this.form.productVariants = this.form.productVariants.filter((variant) => {
            return variant.state !== 'new' && variant.state !== 'hidden';
        });
        // const existingProductVariants = this.form.productVariants || [];
        const newPermutations = [];
        const resultWrapper = [];
        const depthWrapper = 0;
        let index = 0;
        const sectionsWrapperFiltered = sectionsWrapper.filter((section) => {
            return !(section.state === 'deleted' || section.state === 'hidden');
        });
        // Return if product sections count is <= 1
        if (sectionsWrapperFiltered.length <= 1) {
            return [];
        }
        function buildVariantPermutations(sections, depth, result) {
            // Initialize inside array if index = 0
            if (depth === 0 && index === 0) {
                result[0] = [];
            }
            if (depth >= sectionsWrapper.length || sections.length <= 1) {
                return [];
            }
            sections[depth].productOptions.forEach((option) => {
                // Don't add deleted options in permutation
                if (option.deleted || option.hidden) {
                    return;
                }
                // This will make sure that the preceeding values in the array is transferred
                // to deeper depths in the recursion
                if (index > 0 && !!(result[index].filter(() => 1).length < depth)) {
                    result[index] = result[index - 1].slice(0, depth);
                }
                result[index][depth] = option;
                // Deepest product section
                if (depth >= sections.length - 1) {
                    index++;
                    result[index] = [];
                }
                else {
                    return buildVariantPermutations(sections, depth + 1, result);
                }
            });
            return result;
        }
        const result = buildVariantPermutations(sectionsWrapperFiltered, depthWrapper, resultWrapper);
        if (result instanceof Array) {
            result.pop();
            result.forEach((permutation) => {
                const productVariant = new EcommerceProductVariantInputModel();
                permutation.forEach((option) => {
                    productVariant.productOptions.push(option);
                });
                newPermutations.push(productVariant);
                // Add new permutations to form data
                if (!this.isDuplicate(productVariant, this.form.productVariants)) {
                    if (productVariant.state === 'new') {
                        productVariant.price = this.$v?.form?.price?.$model;
                    }
                    this.form.productVariants.push(productVariant);
                }
            });
        }
        // Remove deleted permutations to form data
        this.form.productVariants.forEach((permutation) => {
            if (!this.isDuplicate(permutation, newPermutations)) {
                permutation.state = State.hidden;
            }
            else {
                this.verifySectionIndex(permutation, sectionsWrapperFiltered);
            }
        });
    }
    isDuplicate(variant, variantList) {
        const newVariantName = variant.name;
        for (let x = 0; x < variantList.length; x++) {
            const existingVariant = variantList[x];
            if (existingVariant.name === newVariantName) {
                return true;
            }
        }
        return false;
    }
    verifySectionIndex(variant, sections) {
        const variantOptions = variant.productOptions.map((option) => option.name);
        const sectionOptions = [];
        sections.forEach((section) => {
            const optionNames = section.productOptions.map((option) => option.name);
            sectionOptions.push(optionNames);
        });
        variantOptions.some((option, index) => {
            if (!sectionOptions[index].includes(option)) {
                variant.state = State.hidden;
                return true;
            }
            return false;
        });
    }
    addProductSection() {
        const details = new EcommerceProductSectionInputModel();
        this.form.productSections.push(details);
    }
    addProductCategory() {
        const category = new EcommerceProductCategoryInputModel();
        this.form.productCategories.push(category);
    }
    productSectionErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty('Product Variance');
            errors.push(msg);
        }
        return errors;
    }
    productSectionOptionsErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty('Product Variance Options');
            errors.push(msg);
        }
        if (!v.atLeastOnePublished) {
            const msg = 'Publish At Least One Product Option';
            errors.push(msg);
        }
        return errors;
    }
    isOptionRemovable(option, section) {
        if (this.diy) {
            return true; // allow Default Variance Option to be removed in DIY
        }
        const newOptions = section.productOptions.$model.filter((opts) => {
            return opts.state === 'new' || opts.state === 'idle';
        });
        const newOptionNames = newOptions.map((opt) => opt.name);
        return includes(newOptionNames, option);
    }
    productOptionPriceErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty('Price');
            errors.push(msg);
        }
        if (!v.validAmount) {
            const msg = 'Price must be greater than 0';
            errors.push(msg);
        }
        return errors;
    }
    productOptionStockErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty('Quantity Stock');
            errors.push(msg);
        }
        if (!v.validQuantity) {
            const msg = 'Stock quantity must be greater than -1';
            errors.push(msg);
        }
        if (!v.validStockQuantity) {
            const msg = 'Stock quantity must be greater than -1';
            errors.push(msg);
        }
        return errors;
    }
    productDetailErrors(v) {
        const errors = [];
        const label = 'Product Detail';
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty(label);
            errors.push(msg);
        }
        if (!v.unique) {
            const msg = uniqueProperty(label);
            errors.push(msg);
        }
        return errors;
    }
    productPriceHikeErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty('Additional Price');
            errors.push(msg);
        }
        return errors;
    }
    productPriceHikeCityErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.unique) {
            const msg = uniqueProperty('City');
            errors.push(msg);
        }
        return errors;
    }
    onVarianceChanged(val) {
        if (val && this.form.productSections.length === 0) {
            this.form.productSections.push(new EcommerceProductSectionInputModel());
        }
        if (!val && (!this.update || !this.varianceExists)) {
            this.form.productSections = [];
        }
        if (val && this.update) {
            this.disableVarianceFields = false;
        }
        if (!val && this.update) {
            this.disableVarianceFields = true;
        }
    }
    // private onAddOnsChanged(val: boolean) {
    //   if (val && this.form.productAddOns!.length === 0) {
    //     this.form.productAddOns!.push(new EcommerceProductAddOnInputModel());
    //   }
    //   if (!val && (!this.update || !this.addOnsExists)) {
    //     this.form.productSections = [];
    //   }
    //   if (val && this.update) {
    //     this.disabledAddOnsFields = false;
    //   }
    //   if (!val && this.update) {
    //     this.disabledAddOnsFields = true;
    //   }
    // }
    generateCityPriceHike(region) {
        region.productCityPriceHikes.push(new EcommerceProductCityPriceHikeInputModel());
    }
    onLocationAvailabilityChanged(val) {
        const regionNames = this.form.productRegionAvailabilities.map((region) => region.name);
        const valueNames = val.map((value) => value.name);
        val.forEach((value) => {
            if (!regionNames.includes(value.name)) {
                this.form.productRegionAvailabilities.push(new EcommerceProductRegionAvailabilityInputModel(value, false, []));
            }
        });
        const deleted = (po) => !valueNames.includes(po.name);
        this.form.productRegionAvailabilities.filter(deleted).forEach((po) => po.markAsDeleted());
        const deletedOptions = this.form.productRegionAvailabilities.filter((po) => {
            return po.isDeleted;
        });
        // In case of duplicate value revert option previous state
        deletedOptions.forEach((po) => {
            if (valueNames.includes(po.name)) {
                if (po.uuid) {
                    po.markAsIdle();
                }
                else {
                    po.markAsNew();
                }
            }
        });
    }
    onPromoChanged(val) {
        if (val && !this.form.productPromo) {
            this.form.productPromo = new EcommerceProductPromoInputModel();
        }
        if (!val && (!this.update || !this.promoExists)) {
            this.form.productPromo = null;
        }
        if (val && !!this.form.productPromo && this.update) {
            this.disablePromoFields = false;
        }
        if (!val && !!this.form.productPromo && this.update) {
            this.disablePromoFields = true;
        }
    }
    onOptionsChanged(section, values, basePrice) {
        section.onOptionsChanged(section.name || '', values, basePrice);
        this.buildVariantPermutationsWrapper(this.form.productSections);
    }
    freebieErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!v.required) {
            const msg = requiredProperty('Product Freebie');
            errors.push(msg);
        }
        if (!v.unique) {
            const msg = uniqueProperty('Product Freebie');
            errors.push(msg);
        }
        return errors;
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            if (this.diy) {
                this.segmentTrack('DIY Step 3 - Customize App Products', this.form);
            }
            this.form.digitalProduct = this.form.category === ProductCategory.digitalSale;
            if (this.form.category !== ProductCategory.freebie) {
                this.form.category = ProductCategory.sale;
            }
            this.$emit('submit', this.form);
        }
    }
    isNotFirstCategoryInstance(index) {
        return isNotFirstInstance(index);
    }
    // Disable Combobox Item Deletion Using Delete and Backspace key
    onVarianceOptionDeletion(event) {
        const inputEvent = event;
        if (inputEvent.target.value === '') {
            this.$refs.options[0].blur();
        }
    }
    // Bind Event Listener to `Chip` component and brute force add disable class
    onOptionClick(event) {
        const el = event.target;
        if (el) {
            el.classList.add('hide-action');
            el.classList.add('v-chip--disabled');
            event.stopPropagation();
            return false;
        }
    }
    mounted() {
        if (this.formData) {
            this.buildProductOptionEdges();
            this.form = { ...this.formData };
            const { enableVariances } = this.formData;
            const { enablePromos } = this.formData;
            // const { enableAddOn } = this.formData;
            this.disableVarianceFields = !enableVariances;
            // this.disabledAddOnsFields = !enableAddOn;
            this.varianceExists = this.formData.productSections.length >= 1;
            // this.addOnsExists = this.formData.productAddOns.length >= 1;
            this.disablePromoFields = !enablePromos;
            this.promoExists = !!this.form.productPromo;
            this.setProductOptionDefaultPrice(this.formData.productSections, this.formData.price);
            this.buildVariantPermutationsWrapper(this.form.productSections);
        }
    }
    onPermutationSubmit(formData) {
        this.form.productVariants = formData.productVariants;
    }
    buildProductOptionEdges() {
        if (this.formData) {
            this.formData.productVariants.forEach((variant) => {
                const variantOptions = [];
                if (variant.productOptions.edges) {
                    variant.productOptions.edges.forEach((option) => {
                        variantOptions.push(option.node);
                    });
                }
                variant.productOptions = variantOptions;
            });
        }
    }
};
__decorate([
    Getter('requestOnFlight')
], ProductForm.prototype, "mutationRequestOnFlight", void 0);
__decorate([
    Getter('uploadingImage')
], ProductForm.prototype, "uploadingImage", void 0);
__decorate([
    Mutation('updateProductDetails', { namespace: DIY })
], ProductForm.prototype, "updateProductDetails", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ProductForm.prototype, "formData", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ProductForm.prototype, "update", void 0);
__decorate([
    Prop({ type: String, default: null })
], ProductForm.prototype, "productComponentUuid", void 0);
__decorate([
    Watch('enableDependentStock', { immediate: true })
], ProductForm.prototype, "pushNewProductVariant", null);
__decorate([
    Watch('form', { deep: true })
], ProductForm.prototype, "onFormChanged", null);
ProductForm = __decorate([
    Component({
        components: {
            ActionButton,
            BaseDetails,
            BaseImagePlaceholder,
            BaseTextField,
            BaseTextArea,
            Categories,
            DeliveryAreaRegions,
            DeliveryAreaCities,
            FormHeader,
            Freebies,
            NumericInput,
            SubCategories,
            TheDiyActions,
            Uploader,
            BaseOverlayLoader,
            VueEditor,
            VEditorField,
        },
        filters: {
            emptyText(value, hideText) {
                if (hideText) {
                    return '';
                }
                return value;
            },
        },
        validations() {
            const vm = this;
            const enableVariances = () => vm.form.enableVariances;
            const enablePromos = () => vm.form.enablePromos;
            const { subcategorized } = vm;
            const unDeletedCategory = (category) => !category.isDeleted;
            const unDeletedProductDetail = (detail) => !detail.isDeleted;
            const unDeletedRegionAvailability = (priceHike) => !priceHike.isDeleted;
            // const unDeletedProductAddOn = (detail: EcommerceProductAddOnInputImpl) => !detail.isDeleted;
            // const enableAddOns = () => vm.form.enableAddOn;
            const validations = {
                form: {
                    // productAddOns: {
                    //   $each: {
                    //     name: {
                    //       required: requiredIf((model: EcommerceProductAddOnInputImpl) => {
                    //         return !model.isDeleted;
                    //       }),
                    //       unique: (value: string, model: EcommerceProductAddOnInputImpl) => {
                    //         if (!value || model.isDeleted) {
                    //           return true;
                    //         }
                    //         const details = vm.form.productAddOns.filter(unDeletedProductAddOn);
                    //         const matches = details.filter((detail: EcommerceProductAddOnInputImpl) => {
                    //           return detail.name === value;
                    //         });
                    //         // Match should not greater than 1 including instance
                    //         return matches.length <= 1;
                    //       },
                    //     },
                    //     price: {},
                    //     published: {
                    //       required: requiredIf(enableAddOns),
                    //     },
                    //     uuid: {},
                    //   },
                    // },
                    name: {
                        required,
                    },
                    price: {
                        decimal,
                        required: requiredIf(() => {
                            return !vm.form.enableVariances;
                        }),
                    },
                    compareAtPrice: {
                        decimal,
                        validCompareAt() {
                            if (vm.form.enablePromos) {
                                return true;
                            }
                            if (Number(vm.form.compareAtPrice) > 0.0) {
                                return Number(vm.form.compareAtPrice) > Number(vm.form.price);
                            }
                            return true;
                        },
                    },
                    description: {
                        required,
                    },
                    width: {
                        decimal,
                        required: requiredIf(() => {
                            return vm.appDetails.withLalamoveShipping && vm.form.category === 'physicalSale';
                        }),
                        maxWidth() {
                            return Number(vm.form.width) <= 48;
                        },
                    },
                    length: {
                        decimal,
                        required: requiredIf(() => {
                            return vm.appDetails.withLalamoveShipping && vm.form.category === 'physicalSale';
                        }),
                        maxLength() {
                            return Number(vm.form.length) <= 84;
                        },
                    },
                    height: {
                        decimal,
                        required: requiredIf(() => {
                            return vm.appDetails.withLalamoveShipping && vm.form.category === 'physicalSale';
                        }),
                        maxHeight() {
                            return Number(vm.form.height) <= 40.8;
                        },
                    },
                    weight: {
                        decimal,
                        required: requiredIf(() => {
                            return vm.appDetails.withLalamoveShipping && vm.form.category === 'physicalSale';
                        }),
                        maxWeight() {
                            return Number(vm.form.weight) <= 600;
                        },
                    },
                    skuMatCode: {},
                    quantity: {
                        required: requiredIf((model) => {
                            return model.limited;
                        }),
                        validStockQuantity() {
                            const { limited, quantity } = this.form;
                            if (!limited && !quantity) {
                                return true;
                            }
                            return Number(quantity) > -1;
                        },
                    },
                    kycLevel: {
                        required: requiredIf((model) => {
                            return model.requiredKyc;
                        }),
                    },
                    remarksLabel: {
                        required: requiredIf((model) => {
                            return model.enableProductRemarks;
                        }),
                    },
                    enableProductLocationAvailability: {},
                    regions: {},
                    productRegionAvailabilities: {
                        required: requiredIf((model) => {
                            return model.enableProductLocationAvailability;
                        }),
                        $each: {
                            uuid: {},
                            regionCode: {},
                            name: {},
                            productCityPriceHikes: {
                                $each: {
                                    uuid: {
                                        unique: (value, model) => {
                                            if (!value || model.isDeleted) {
                                                return true;
                                            }
                                            const regions = vm.form.productRegionAvailabilities.filter(unDeletedRegionAvailability);
                                            const priceHikes = regions.flatMap((y) => {
                                                return y.productCityPriceHikes;
                                            });
                                            const undeletedPriceHikes = priceHikes.filter((priceHike) => {
                                                return !priceHike.isDeleted;
                                            });
                                            const uuids = undeletedPriceHikes.map((priceHike) => {
                                                return priceHike.uuid;
                                            });
                                            const matches = uuids.filter((uuid) => {
                                                return uuid === value;
                                            });
                                            return matches.length <= 1;
                                        },
                                    },
                                    price: {
                                        required: requiredIf((model) => {
                                            return !model.isDeleted;
                                        }),
                                    },
                                },
                            },
                        },
                    },
                    productSections: {
                        $each: {
                            name: {
                                required: requiredIf((model) => {
                                    return model.state !== 'deleted' && enableVariances();
                                }),
                            },
                            options: {
                                required: requiredIf((model) => {
                                    return model.state !== 'deleted' && enableVariances();
                                }),
                                atLeastOnePublished: () => {
                                    if (!vm.form.enableVariances) {
                                        return true;
                                    }
                                    const options = vm.form.productSections[0].productOptions;
                                    const publishedOptions = options.filter((option) => {
                                        return option.isPublished;
                                    });
                                    return publishedOptions.length >= 1;
                                },
                            },
                            published: {},
                            productOptions: {
                                $each: {
                                    published: {},
                                    digitalProduct: {},
                                    name: {
                                        required: requiredIf(() => {
                                            enableVariances();
                                        }),
                                    },
                                    price: {
                                        required: requiredIf((model) => {
                                            return model.fresh && vm.form.enableVariances;
                                        }),
                                        validAmount: (value, model) => {
                                            if (!vm.form.enableVariances) {
                                                return true;
                                            }
                                            if (value > 0 || model.deleted || !model.isPublished) {
                                                return true;
                                            }
                                            return false;
                                        },
                                    },
                                    compareAtPrice: {
                                        validCompareAt: (value, model) => {
                                            if (vm.form.enablePromos) {
                                                return true;
                                            }
                                            if (value > 0.0 && !!model) {
                                                return value > Number(model?.price);
                                            }
                                            return true;
                                        },
                                    },
                                    boughtAndReservedCount: {},
                                    stockQuantity: {
                                        numeric,
                                        required: requiredIf((model) => {
                                            return model.limited && vm.form.enableVariances;
                                        }),
                                        validQuantity: (value, model) => {
                                            if (!vm.form.enableVariances) {
                                                return true;
                                            }
                                            if (!value || model.deleted) {
                                                return true;
                                            }
                                            if (!vm.form.limited && !vm.form.quantity) {
                                                return true;
                                            }
                                            return Number(value) > -1;
                                        },
                                        validStockQuantity: (value, model) => {
                                            if (!vm.form.enableVariances) {
                                                return true;
                                            }
                                            if (!value || model.deleted) {
                                                return true;
                                            }
                                            if (!vm.form.limited && !vm.form.quantity) {
                                                return true;
                                            }
                                            return Number(value) > -1;
                                        },
                                    },
                                    limited: {},
                                },
                            },
                        },
                    },
                    productDetails: {
                        $each: {
                            content: {
                                required: requiredIf((model) => {
                                    return !model.isDeleted;
                                }),
                                unique: (value, model) => {
                                    if (!value || model.isDeleted) {
                                        return true;
                                    }
                                    const details = vm.form.productDetails.filter(unDeletedProductDetail);
                                    const matches = details.filter((detail) => {
                                        return detail.content === value;
                                    });
                                    // Match should not greater than 1 including instance
                                    return matches.length <= 1;
                                },
                            },
                        },
                    },
                    productPromo: {
                        discount: {
                            required: requiredIf(enablePromos),
                            mustBeLessThanPrice() {
                                const { price, productPromo, productSections } = this.form;
                                let minPrice = 0;
                                if (enableVariances()) {
                                    minPrice = Math.min(...productSections[0]?.productOptions
                                        ?.map((option) => option?.price)
                                        .filter((optPrice) => optPrice !== null));
                                }
                                else {
                                    minPrice = price;
                                }
                                if (productPromo) {
                                    if (productPromo.discountType === DiscountType.absolute) {
                                        return minPrice > productPromo.discount;
                                    }
                                    const maxPercentage = 100;
                                    return productPromo.discount < maxPercentage;
                                }
                                return true;
                            },
                        },
                        discountType: {
                            required: requiredIf(enablePromos),
                        },
                        paymentOptions: {
                            required: requiredIf(enablePromos),
                        },
                        freebies: {
                            $each: {
                                uuid: {
                                    required: requiredIf((model) => {
                                        return !model.isDeleted;
                                    }),
                                    unique: (value, model) => {
                                        if (!value || model.isDeleted) {
                                            return true;
                                        }
                                        return !vm.form.productPromo.freebieExists(value);
                                    },
                                },
                            },
                        },
                    },
                    productCategories: {
                        $each: {
                            uuid: {
                                required: requiredIf((model) => {
                                    if (vm.isProductFreebie) {
                                        return false;
                                    }
                                    return unDeletedCategory(model);
                                }),
                                unique: (value, model) => {
                                    if (!value || model.isDeleted) {
                                        return true;
                                    }
                                    const categories = vm.form.productCategories.filter(unDeletedCategory);
                                    const matches = categories.filter((category) => {
                                        return category.uuid === value;
                                    });
                                    // Match should not greater than 1 including instance
                                    return matches.length <= 1;
                                },
                            },
                        },
                    },
                },
            };
            // Dynamically Set Validation Schema For Subcategory when subcategorized
            // is set to true
            if (subcategorized && !vm.isProductFreebie) {
                return {
                    form: {
                        ...validations.form,
                        productCategories: {
                            $each: {
                                ...validations.form.productCategories.$each,
                                subCategoryUuids: {
                                    required: requiredIf((model) => {
                                        return unDeletedCategory(model);
                                    }),
                                },
                                subcategories: {},
                            },
                        },
                    },
                };
            }
            return validations;
        },
    })
], ProductForm);
export default ProductForm;
